// extracted by mini-css-extract-plugin
export default {"card":"card__1otP9","cardHeader":"cardHeader__s9fUv","cardImg":"cardImg__2HKO3","cardTitle":"cardTitle__1MXvk","cardContent":"cardContent__1LARU","cardSummary":"cardSummary__3BWJN","cardPrice":"cardPrice__1DLXK","price":"price__EaErV","offerButton":"offerButton__36UtV","tooltipButton":"tooltipButton__f3M8k"};
    if(module.hot) {
      // 1745482221091
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  